/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetTrialStatusQueryResponse, GetTrialStatusPathParams, GetTrialStatus400, GetTrialStatus401, GetTrialStatus403, GetTrialStatus404, GetTrialStatus409, GetTrialStatus500 } from "../../types/platformBillingController/GetTrialStatus.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getTrialStatus } from "../../client/platformBillingController/getTrialStatus.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTrialStatusQueryKey = (organizationId: GetTrialStatusPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/platform-billing/trial-status', params: {organizationId:organizationId} }] as const

export type GetTrialStatusQueryKey = ReturnType<typeof getTrialStatusQueryKey>

export function getTrialStatusQueryOptions(organizationId: GetTrialStatusPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getTrialStatusQueryKey(organizationId)
        return queryOptions<GetTrialStatusQueryResponse, ResponseErrorConfig<GetTrialStatus400 | GetTrialStatus401 | GetTrialStatus403 | GetTrialStatus404 | GetTrialStatus409 | GetTrialStatus500>, GetTrialStatusQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getTrialStatus(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get trial status
 * {@link /api/organizations/:organizationId/platform-billing/trial-status}
 */
export function useGetTrialStatus<TData = GetTrialStatusQueryResponse, TQueryData = GetTrialStatusQueryResponse, TQueryKey extends QueryKey = GetTrialStatusQueryKey>(organizationId: GetTrialStatusPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetTrialStatusQueryResponse, ResponseErrorConfig<GetTrialStatus400 | GetTrialStatus401 | GetTrialStatus403 | GetTrialStatus404 | GetTrialStatus409 | GetTrialStatus500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getTrialStatusQueryKey(organizationId)
         

         const query = useQuery({
          ...getTrialStatusQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetTrialStatus400 | GetTrialStatus401 | GetTrialStatus403 | GetTrialStatus404 | GetTrialStatus409 | GetTrialStatus500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}